import { useState, useEffect } from 'react';

// useThreadArchivistEvents opens an SSE stream to
// GET /api/threads/{urn}/archivist-events and accumulates events.
//
// The stub operator handler emits only keepalive comments, so `events`
// will be empty until the JetStream archivist subject is provisioned.
// Any JSON-parseable SSE data frame is appended to the returned array.
//
// Returns [] when threadURN is null/undefined.
export function useThreadArchivistEvents(threadURN) {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (!threadURN) return;

    const url = `/api/threads/${encodeURIComponent(threadURN)}/archivist-events`;
    const es = new EventSource(url, { withCredentials: true });

    es.onmessage = (e) => {
      try {
        const ev = JSON.parse(e.data);
        setEvents(prev => [...prev, ev]);
      } catch {
        // Ignore non-JSON frames (keepalive comments never reach onmessage).
      }
    };

    return () => es.close();
  }, [threadURN]);

  return events;
}
